import { render } from "./FAQComponent.vue?vue&type=template&id=2f57d6cd&scoped=true"
import script from "./FAQComponent.vue?vue&type=script&lang=js"
export * from "./FAQComponent.vue?vue&type=script&lang=js"

import "./FAQComponent.vue?vue&type=style&index=0&id=2f57d6cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f57d6cd"]])

export default __exports__